import { render } from "./CronJobs.vue?vue&type=template&id=195d603a"
import script from "./CronJobs.vue?vue&type=script&lang=js"
export * from "./CronJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__